<template>
  <div v-cloak class="hello container">
    <!--  电脑端-->
    <div class="heard flex f-between hidden-xs-only">
      <div>
        <div class="imgs">
          <img src="../img/logo.png" alt="" @click="toPage" />
        </div>
        <div class="title">
          <div
            @click="toggle(list.path)"
            v-for="(list, indexs) in titles"
            :key="indexs"
            :class="list.path == paths ? 'actives' : 'title-c'"
          >
            {{ list.name }}
          </div>
          <div @click="toShisw()" class="title-c">SHISW</div>
        </div>
        <!-- <el-input class="search" @change="search" placeholder="搜索点什么" suffix-icon="el-icon-search" v-model="input2"></el-input>
			<span class="se">搜索</span> -->
      </div>
      <div class="loginss">
        <span class="usernames" v-if="logintype" @click="login">{{
          names == "undefined"
            ? "你好，会员用户"
            : names == "登录"
            ? names
            : "您好，" + names
        }}</span>
        <el-divider v-if="logintype" direction="vertical"></el-divider>
        <span v-if="loginstatus" class="quits" @click="quit">退出登录</span>
        <span v-if="!loginstatus" @click="register">注册</span>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="heard hidden-sm-and-up">
      <div class="flex f-between">
        <div class="imgs">
          <img src="../img/logo.png" alt="" @click="toPage" />
        </div>
        <div>
          <i class="el-icon-menu fon-30 pa-r-20" @click="tiggerMenu"></i>
        </div>
      </div>
      <div class="menu-wrap"  id="menu-wrap">
        <div class="menu-head">
          <div
            @click="toggle(list.path)"
            v-for="(list, indexs) in titles"
            :key="indexs"
            class="menu-item"
          >
            {{ list.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quitlogin, getuser } from "../api.js";
import 'element-ui/lib/theme-chalk/display.css';
// import store from "../store/index.js";
export default {
  name: "Heard",
  props: {
    msg: String,
  },
  data() {
    return {
      titles: [
        { name: "关于社区", path: "/", index: "0" },
        { name: "国际影展", path: "/Resource", index: "1" },
        // { name: "展映基地", path: "/Practice", index: "3" },
        //{ name: "关于方舟", path: "/About", index: "4" },
        { name: "创作训练营", path: "/Learn", index: "2" },
        { name: "服务中心", path: "/Datum", index: "5" },
        { name: "创作者调研", path: "/Survey", index: "7" },
        //{ name: "众筹", path: "/crowdfunding/list", index: "8" },
       // { name: "活动", path: "/event/list", index: "9" },
        { name: "会员中心", path: "/User", index: "6" },

      ],
      input2: "",
      paths: "/",
      names: "", //用户姓名
      logintype: "", //shifou登录
      loginstatus: "", //是否登录
    };
  },
  created() {
    let token = localStorage.getItem("AccessToken") || "";

    // token ? (this.loginstatus = true) : (this.loginstatus = false);
    if (token) {
      getuser({ token: token }).then((res) => {
        this.names = res.data.Data.Nickname;
      });
      this.loginstatus = true;
      this.logintype = true;
    } else {
      this.loginstatus = false;
      this.logintype = true;
      this.names = "登录";
    }
  },
  filters: {
    sn(e) {
      if (e) {
        return e.length > 4 ? e.slice(0, 4) + "..." : e;
      } else {
        return e;
      }
    },
  },

  watch: {
    $route(to) {
      this.paths = to.path;
      if (to.path == "/Login" || to.path == "/Register" || to.path == "/Find") {
        let token = localStorage.getItem("AccessToken") || "";

        if (token) {
          this.loginstatus = true;
          this.logintype = true;
          getuser({ token: token }).then((res) => {
            this.names = res.data.Data.Nickname;
          });
        } else {
          this.loginstatus = false;
          this.logintype = true;
          this.names = "登录";
        }
      } else {
        let token = localStorage.getItem("AccessToken");

        if (token) {
          this.loginstatus = true;
          this.logintype = true;
          getuser({ token: token }).then((res) => {
            this.names = res.data.Data.Nickname;
          });
        } else {
          this.loginstatus = false;
          this.logintype = true;
          this.names = "登录";
        }
      }
    },
  },

  methods: {
    //顶部菜单显隐藏
    tiggerMenu(){
      let dom=document.getElementById('menu-wrap')
      console.log(dom.scrollHeight)
      if(dom.style.height=='0px' || !dom.style.height){
        dom.style.height=dom.scrollHeight+'px'
      }else{
        dom.style.height='0px'
      }
      
    },
    //跳转SHISW
    toShisw() {
      let data = {
        AccessToken: localStorage.getItem("AccessToken"),
        RefreshToken: localStorage.getItem("RefreshToken"),
        AccessTokenTime: localStorage.getItem("AccessTokenTime"),
        username: localStorage.getItem("username"),
        RefreshTokenTime: localStorage.getItem("RefreshTokenTime"),
      };
      if (data.AccessToken) {
        let url = "http://shisw.net?uToken=" + JSON.stringify(data);
        window.open(url, "_blank");
      } else {
        window.open("http://www.shisw.net", "_blank");
      }
    },
    toPage() {
      this.$router.push({ path: "/" });
    },
    toggle(path) {
      this.paths = path;
      this.$router.push(`${path}`);

      // 隐藏导航栏
      this.tiggerMenu()
    },
    login() {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$router.push("/Login");
      }
    },
    register() {
      this.$router.push("/Register");
    },

    quit() {
      let token = localStorage.getItem("AccessToken");
      let datas = {
        Source: "web",
        Token: token,
      };

      this.$confirm("您确定退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        quitlogin(datas).then((res) => {
          if (res.data.Code == 0) {
            localStorage.removeItem("AccessToken");
            localStorage.removeItem("RefreshToken");
            localStorage.removeItem("username");
            localStorage.removeItem("AccessTokenTime");
            localStorage.removeItem("RefreshTokenTime");
            localStorage.removeItem("videostatus");
            localStorage.removeItem("ppttoken");
            this.names = "登录";
            this.loginstatus = false;
            this.$message({
              message: "退出登录成功",
              type: "success",
            });
            setTimeout(() => {
              //如果在首页退出，则重定向到首页，达到去除url参数目的。
              if (this.$route.name == "Home") {
                this.$router.replace({ path: "/" });
              } else {
                this.$router.go(0);
              }
            }, 500);
          }
        });
      });
    },
  },
};
</script>


<style lang="scss">
.hidden-xs-only{
  min-width: 1200px;
}
#menu-wrap{
  transition: height .3s;
  height: 0px;
}
.menu-wrap{
  // position: fixed;
  // top: 0;
  // left: 0;
  // height: 100vh;
  // width: 100vw;
  // background: ;
  .menu-head{
    background: #fff;
    width: 100%;
    text-align: center;
  .menu-item{
    line-height: 45px;
    border-bottom: 1px solid #eee;
  }
}
}

.hello {
  // min-width: 1200px;
  // height: 88px;
  line-height: 88px;
  box-sizing: border-box;
}
.hello .heard {
  // width: 1200px;
  margin: 0 auto;
  overflow: auto;
  box-sizing: border-box;
  position: relative;
}
@media  (max-width: 768px){
  .hello .heard {
    overflow:hidden;
  }
}
.hello .heard .imgs {
  width: 180px;
  height: 100%;
  float: left;
  display: flex;
  align-items: center;
  margin-right: 50px;
}
.hello .heard .imgs img {
  width: 100%;
  // height:100%;
  line-height: 88px;
}
.hello .title {
  float: left;
  margin-right: 20px;
}
.hello .title-c {
  // width:64px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-right: 20px;
  cursor: pointer;
  float: left;
}
.actives {
  font-size: 16px;
  border-bottom: 3px solid #fb004d;
  font-weight: bold;
  color: #fb004d;
  margin-right: 20px;
  cursor: pointer;
  float: left;
}
.hello .search {
  width: 253px;
  height: 32px;
  border-radius: 16px;
  float: left;
}
.hello .el-input__inner {
  border-radius: 16px;
}
.loginss {
  display: flex;
  position: absolute;
  right: 0;
  margin-left: 15px;
  align-items: center;
  span {
    // font-weight: 600;
    font-size: 14px;
    cursor: pointer;
  }
  .usernames {
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    text-align: right;
  }
}
.se {
  display: inline-block;
  margin-left: 10px;
  font-size: 14px;
  cursor: pointer;
  opacity: 0.9;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
}
</style>
